import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';

function ModalBodyDivider({ title, className, buttonBelow = false }) {
  const classes = useStyles({ buttonBelow });

  return (
    <div className={classNames(classes.container, className)}>
      <div className={classes.bar} />

      {title && (
        <>
          <div className={classes.text}>{title}</div>
          <div className={classes.bar} />
        </>
      )}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: layoutDefaults.fontSize,
    marginTop: layoutDefaults.bigVerticalMargin,
    marginBottom: ({ buttonBelow }) =>
      buttonBelow
        ? layoutDefaults.smallVerticalMargin + 2
        : layoutDefaults.bigVerticalMargin,
  },
  bar: {
    flex: 1,
    height: 1,
    backgroundColor: 'black',
    opacity: 0.15,
  },
  text: {
    opacity: layoutDefaults.smallOpacity,
    marginLeft: layoutDefaults.horizontalMargin,
    marginRight: layoutDefaults.horizontalMargin,
  },
});

export { ModalBodyDivider };
